import React from 'react';
import { Flex, classNames } from '@tpr/core';
import { CheckedCircle, ErrorCircle } from '@tpr/icons';
import { StatusMessage } from './card';
import styles from '../cards.module.scss';
export var Toolbar = function (_a) {
    var _b;
    var complete = _a.complete, subtitle = _a.subtitle, buttonLeft = _a.buttonLeft, buttonRight = _a.buttonRight, extraPB = _a.extraPB, statusText = _a.statusText;
    return (React.createElement("div", { className: classNames([
            (_b = {}, _b[styles.complete] = complete, _b),
            styles.cardToolbar,
            extraPB && styles.extraPB,
        ]) },
        React.createElement(Flex, { cfg: {
                width: 5,
                flex: '0 0 auto',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                pr: 4,
            } },
            buttonLeft(),
            subtitle && (React.createElement(Flex, { cfg: { mt: 1, flexDirection: 'column' } }, subtitle()))),
        React.createElement(Flex, { cfg: {
                width: 5,
                flex: '0 0 auto',
                justifyContent: 'flex-end',
                alignItems: 'flex-start',
                pl: 4,
            } },
            React.createElement(StatusMessage, { complete: complete, icon: complete ? CheckedCircle : ErrorCircle, text: statusText }),
            React.createElement("div", { className: styles.verticalHr }),
            React.createElement(Flex, { cfg: { alignItems: 'flex-start' } }, buttonRight()))));
};
//# sourceMappingURL=toolbar.js.map